import { getLoginToken, onTokenChange } from 'App/helpers/meteor-apollo-accounts'
import baseURL from './url'
import getFingerprint from 'App/helpers/getFingerprint'
import { BatchHttpLink } from '@apollo/client/link/batch-http'
import { ApolloClient, InMemoryCache } from '@apollo/client'
import { setContext } from '@apollo/client/link/context'
import { from } from '@apollo/client/core'
import ApolloError from './ApolloError'
import { defaultDataIdFromObject } from '@apollo/client'
import { onError } from '@apollo/client/link/error'
import { persistCache, LocalForageWrapper } from 'apollo3-cache-persist'
import localforage from 'localforage'
import getEnv from './getEnv'

window.apolloErrorComponent = ApolloError

const link = new BatchHttpLink({
  uri: `${baseURL}/graphql`,
  batchMax: 10, // No more than 5 operations per batch
  batchInterval: 50, // Wait no more than 20ms after first batched operation
})

// If error redirect using react router v6 to the error page
// const neverRedirectPathsRegex = [
//   /^\/login/,
//   /^\/authorize/,
//   /^\/verify-email/,
//   /^\/invalid-token/,
//   /^\/exchange/,
//   /^\/register/,
//   /^\/forgot/,
//   /^\/reset/,
//   /^\/logout/,
//   /^\/enroll/,
//   /^\/terms-and-conditions/,
//   /^\/privacy-policy/,
//   /^\/kyc/,
//   /^\/new-kyc/,
// ]

const onlyRedirectPathsRegex = [
  /^\/trade/,
  /^\/accounts/,
  /^\/settings/,
  /^\/history/,
  /^\/developers/,
  /^\/reports/,
]

const checkRedirect = pathname => {
  for (const regex of onlyRedirectPathsRegex) {
    if (!regex.test(pathname)) return false
  }
  return true
}

const errorLink = onError(({ graphQLErrors, networkError }) => {
  if (graphQLErrors) {
    for (const graphqlError of graphQLErrors) {
      if (graphqlError.message.includes('[unauthorizedSession]')) {
        if (checkRedirect(window.location.pathname)) window.location.href = '/authorize'
      } else if (graphqlError.message.includes('[invalidToken]')) {
        // if (checkRedirect(window.location.pathname))
        // window.location.href = '/invalid-token?r=' + window.location.pathname
      } else if (graphqlError.message.includes('[verifyEmail]')) {
        if (checkRedirect(window.location.pathname)) window.location.href = '/verify-email'
      }
    }
  }

  if (networkError) console.error(`[Network error]: ${networkError}`)
})

const authHeaders = setContext(async (request, { headers }) => {
  const currentUserToken = await getLoginToken()
  return {
    headers: {
      ...headers,
      fingerprint: await getFingerprint(),
      ...(currentUserToken ? { 'login-token': await getLoginToken() } : {}),
    },
  }
})

const cache = new InMemoryCache({
  dataIdFromObject: result => {
    if (result._id && result.__typename) {
      return result.__typename + ':' + result._id
    }
    if (result.id && result.__typename) {
      return result.__typename + ':' + result.id
    }
    const typesWithCode = ['Market', 'Currency', 'Country']
    if (typesWithCode.includes(result.__typename) && result.code) {
      return result.__typename + ':' + result.code
    }
    return defaultDataIdFromObject(result)
  },
  possibleTypes: {
    MergeableTypes: [
      'PaginatedOrder',
      'LastTransaction',
      'FeeOption',
      'Market',
      'MarketOrderBook',
      'MarketBookOrder',
      'MarketTrade',
      'MarketStatsPoint',
      'Order',
      'Currency',
      'User',
      'UserProfile',
      'Wallet',
      'Wallets',
      'CryptoAddress',
    ],
  },
  typePolicies: {
    MergeableTypes: {
      merge: true,
    },
  },
})

persistCache({
  cache,
  storage: new LocalForageWrapper(localforage),
})

const env = getEnv()

// onError gets the error and if the graphQLErrors is includes one of these strings, unauthorizedSession, invalidToken, verifyEmail, then it has to update a context variable to show the corresponding component
const apollo = new ApolloClient({
  connectToDevTools: env === 'prod' ? false : true,
  link: from([authHeaders, errorLink, link]),
  cache,
})
window.apollo = apollo

onTokenChange(function () {
  apollo.resetStore()
})

export default apollo
